import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import { browserHistory } from 'react-router'
import {LoadMore} from 'react-weui'
import SchedulePanel from '../../pages/schedule/SchedulePanel'
import ScheduleItem from '../../pages/schedule/ScheduleItem'
import {WKCurrencyItem, WkPanel} from '../wk'
import { TimeStream, renderLectureTimeStream } from '../../utils'
import '../../css/page/LiveroomPage.css'

class LiveroomSchduleListArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isPending: false,
            offset: 0,
            hasMore: true,
            schedules: null,
            total: 0,
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/liveroom/${this.props.liveroom_id}/schedule_list`, {
            params: {
                offset: this.state.offset,
            }
        })
            .then(res => {
                this.setState({
                    schedules: (this.state.schedules || []).concat(res.data.data.schedules),
                    isPending: false,
                    offset: res.data.data.next_offset,
                    hasMore: res.data.data.has_more,
                    total: res.data.data.total_count,
                })
            })
    }
    getBtnInfo (item) {
        if (item.schedule.process === 'close') {
            return {
                text: '已结束',
                isDisable: true,
            }
        }
        if (item.schedule.process === 'not_start') {
            if (item.access) {
                return {
                    text: '已参与',
                    isDisable: true,
                }
            } else {
                return {
                    text: '参与',
                    isDisable: false,
                }
            }
        }
        if (item.schedule.process === 'starting') {
            if (item.is_signin_today) {
                return {
                    text: '已打卡',
                    isDisable: true,
                }
            } else {
                return {
                    text: '打卡',
                    isDisable: false,
                }
            }
        }
    }
    renderLoadStyle() {
        const { hasMore, isPending } = this.state
        if (hasMore) {
            if (!isPending) {
                return (
                    <div className="weui-padding text-center liveroom-loadmore-container" onClick={e => this.fetchData()}>
                        <a className="block text-center liveroom-loadmore">
                            查看更多
                        </a>
                    </div>
                )
            } else {
                return (
                    <LoadMore loading className="liveroom-page-container_loading">正在加载</LoadMore>
                )
            }
        } else {
            return null
        }
    }
    getTimeStr (item) {
        // if (!this.props.role.is_manager && item.schedule.process === 'close') {
        //     return '已结束'
        // }
        if (this.props.role.is_manager || item.schedule.process !== 'not_start') {
            return `${TimeStream(item.schedule.beg_timestamp, 'YMD')} 至 ${TimeStream(item.schedule.end_timestamp, 'YMD')}`
        } else {
            if (TimeStream(item.schedule.beg_timestamp, '-H') > 24) {
                return renderLectureTimeStream(item.schedule.beg_timestamp)
            } else {
                return TimeStream(item.schedule.beg_timestamp, '-H') + '小时后'
            }
        }
    }
    render() {
        const schedules = this.state.schedules
        if (!schedules || schedules.length === 0) {
            return null
        }
        return (
            <div className="liveroom-schdule-list liveroom-page-container" style={{marginTop: '10px'}}>
                <WkPanel title={`打卡${this.state.total > 3 ? `（${this.state.total}）` : ''}`} isNoPadding={true}>
                    {
                        schedules && schedules.map(item => (
                            <ScheduleItem 
                                item={item}
                                key={item.schedule.id}
                                id={item.schedule.id}
                                banner={item.schedule.banner}
                                title={item.schedule.name}
                                signinCount={item.schedule.current_day}
                                joinCount={item.participate_count}
                                time={this.getTimeStr(item)}
                                btnText={this.getBtnInfo(item).text}
                                isBtnDisabled={this.getBtnInfo(item).isDisable}
                                onClick={e => location.assign(`/schedule/${item.schedule.id}`)}
                                isHideBtn={false}
                            />
                        ))
                    }
                </WkPanel>
                {this.renderLoadStyle()}
            </div>
        )
    }

}

export default connect(state => ({
    // liveroom_id: state.liveroom.liveroom.id,
    role: state.liveroom.role,
}))(LiveroomSchduleListArea)


// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomSchduleListArea.js